import styled from 'styled-components'

export const Container = styled.li`
	position: relative;
	display: flex;
	align-items: flex-start;
	min-height: 73px;
	margin-bottom: 16px;
	column-gap: 6px;

	&:not(:last-child):before {
		content: '';
		position: absolute;
		top: 36px;
		left: 36px;
		width: 2px;
		bottom: -52px;
		background-color: ${({ theme }) => theme.color.border};
	}
`
